<template>
  <div class="shadow-card mb-3" style="position: relative">
    <div :style="{ display: 'flex', alignItems: 'center' }">
      <div style="position: relative">
        <a-avatar
          @click="() => viewProfile('reviewee')"
          :style="{ color: ' #ffffff !important', backgroundColor: image ? '' : getAvatarColor(review.reviewee_id) }"
          :src="image"
          alt="profile_image"
          :size="70"
          class="text-capitalize cp fw700 font16"
        >
          {{ name ? name[0] : ""
          }}{{
            name &&
            name
              .split(" ")
              .slice(1)
              .join(" ")
              ? name
                  .split(" ")
                  .slice(1)
                  .join(" ")[0]
              : ""
          }}
        </a-avatar>
        <a-avatar
          :style="{
            color: '#ffffff !important',
            backgroundColor: review.reviewer[0].url ? '' : getAvatarColor(review.reviewer_id),
            fontSize: '8px  !important',
            position: 'absolute',
            right: isProfile ? '-10px' : 0,
            bottom: isProfile ? '12px' : 0,
            borderColor: 'white',
            borderWidth: '1px',
            borderStyle: 'solid',
          }"
          :src="review.reviewer[0].url"
          alt="profile_image"
          :size="24"
          class="text-capitalize avatar-badge fw700"
        >
          {{ review.reviewer[0].display_name ? review.reviewer[0].display_name[0] : review.reviewer[0].first_name[0] }}
        </a-avatar>
      </div>
      <div :style="{ flex: 1, 'margin-left': '16px' }">
        <div class="mobile-view" :style="{ flexDirection: isProfile ? 'row' : 'column' }">
          <p class="text-name m-0 pr-2 cp" @click="() => viewProfile('reviewee')">{{ name }}{{ title }}</p>
          <span class="text-reviewed"> <font-awesome-icon class="font18 text-black mr-2" :icon="['fal', 'star']" />has been reviewed</span>
        </div>
        <!-- <p class="text-day">{{ time }}</p> -->
        <p class="text-day align-items-center" :style="{ display: 'flex', ColumnGap: '2px', flexWrap: 'wrap' }">
          <span class="text-name-2 pr-1">
            by
            <!-- {{
              authUser.user.id === review.reviewer[0].id && authUser.user.role === review.reviewer[0].role
                ? "You"
                : review.reviewer[0].display_name
                ? review.reviewer[0].display_name
                : review.reviewer[0].first_name + " " + review.reviewer[0].last_name
            }} -->
            <!-- Verified user -->
            {{ authUser.user.id === review.reviewer[0].id && authUser.user.role === review.reviewer[0].role ? "You" : "Verified user" }}
          </span>
          {{ time }}
        </p>
      </div>
      <div class="cont">
        <p class="text-day br8 fw700 py-1 px-2" :style="{ color: getPrimaryColor(), background: getPrimary50Color(), marginLeft: 0, textAlign: 'center', width: 'fit-content' }">
          {{ reviewType === "InPerson" ? "In person visit" : reviewType === "Online" ? "Online TeleMedicine" : reviewType }}
        </p>
        <div class="star-cont">
          <div class="str-grp">
            <ReviewStar :rating="Number(review.rating.toFixed(1))" :height="24" :width="24" />
            <p class="review-text">{{ review.rating.toFixed(1) }}</p>
          </div>
          <font-awesome-icon v-if="!expand" @click="expand = !expand" class="cp gray400 font24" :icon="['fas', 'angle-down']" />
          <font-awesome-icon v-if="expand" @click="expand = !expand" class="cp gray400 font24" :icon="['fas', 'angle-up']" />
        </div>
      </div>
    </div>
    <a-divider v-if="expand" class="divider-line" type="horizontal" style="margin: 16px 0px" />
    <a-divider class="divider-line-mob" type="horizontal" style="margin: 16px 0px" />
    <div class="cont-mob">
      <p class="text-day" :style="{ color: getPrimaryColor(), background: getPrimary50Color(), marginLeft: 0, textAlign: 'center', borderRadius: '4px', width: 'fit-content', padding: '0px 8px' }">
        {{ reviewType === "InPerson" ? "In person visit" : reviewType === "Online" ? "Online TeleMedicine" : reviewType === "MyCircles" ? "MyCircles" : reviewType }}
      </p>
      <div class="star-cont">
        <div class="str-grp">
          <ReviewStar :rating="Number(review.rating.toFixed(1))" :height="24" :width="24" />
          <p class="review-text">{{ review.rating.toFixed(1) }}</p>
        </div>
        <div style="flex: 1"></div>
        <font-awesome-icon v-if="!expand" @click="expand = !expand" class="cp gray400 font24" :icon="['fas', 'angle-down']" />
        <font-awesome-icon v-if="expand" @click="expand = !expand" class="cp gray400 font24" :icon="['fas', 'angle-up']" />
      </div>
    </div>
    <!-- <div :style="{ display: 'flex', alignItems: 'center' }">
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            backgroundColor: review.reviewer[0].url ? '' : '#C997C5',
            fontSize: '12px',
            fontWeight: '900'
          }"
          :src="review.reviewer[0].url"
          :size="40"
          class="text-capitalize"
        >
          {{
            review.reviewer[0].display_name
              ? review.reviewer[0].display_name[0]
              : ""
          }}
        </a-avatar>
        <div :style="{ flex: 1 }">
          <p
            class="text-name"
            :style="{ marginBottom: '0px', textTransform: 'capitalize' }"
          >
            {{ review.reviewer[0].display_name }}
          </p>
          <div :style="{ marginLeft: '16px' }" v-if="reviewType != null">
            <p
              class="text-day"
              :style="{
                color: getPrimaryColor(),
                background: getPrimary50Color(),
                marginLeft: 0,
                textAlign: 'center',
                borderRadius: '4px',
                width: 'fit-content',
                padding: '0px 8px'
              }"
            >
              {{
                reviewType === "InPerson"
                  ? "Practice Visit"
                  : reviewType === "Online"
                  ? "TeleMedicine"
                  : reviewType === "MyCircles"
                  ? "Online Consultation"
                  : reviewType
              }}
            </p>
          </div>
        </div>
        <div
          class="star-container"
          :style="{
            background: getPrimaryColor()
          }"
        >
          <font-awesome-icon
            size="2x"
            style="transform: scale(0.7); width: 24px; height: 24px; color: white"
            :icon="['fas', 'star']"
          />
        </div>
        <p class="review-text">{{ review.rating.toFixed(1) }}</p>
        <font-awesome-icon
          v-if="!expand"
          @click="expand = !expand"
          size="2x"
          style="transform: scale(0.7); width: 24px; height: 24px; margin-left: 20px; color: #94A3B8; cursor: pointer;"
          :icon="['fas', 'angle-down']"
        />
        <font-awesome-icon
          v-if="expand"
          @click="expand = !expand"
          size="2x"
          style="transform: scale(0.7); width: 24px; height: 24px; margin-left: 20px; color: #94A3B8; cursor: pointer;"
          :icon="['fas', 'angle-up']"
        />
      </div> -->
    <div v-if="expand">
      <p
        class="review-description"
        :style="{ marginBottom: description ? (description.length > 150 ? '0px' : '16px') : '0px' }"
        v-html="seeMore ? getLimitedDescription(description) : description"
      ></p>
      <div v-if="description">
        <p style="padding: 16px 0px" v-if="description.length > 150 && seeMore" @click="seeMore = !seeMore">
          <span class="see-more">see more</span>
        </p>
        <!-- <p style="padding: 16px 0px" v-if="description.length > 150 && !seeMore" @click="seeMore = !seeMore">
          <span class="see-more">see less</span>
        </p> -->
      </div>
      <div class="rate-box-container">
        <div class="rate-box" v-for="(item, index) in rating_list" v-if="rating_value_list[index]">
          {{ item }}
          <!-- <i
              class="fa fa-star-o"
              aria-hidden="true"
              :style="{
                color: getPrimaryColor(),
                width: '24px'
              }"
            ></i> -->
          <div class="d-flex">
            <ReviewStar :rating="Number(rating_value_list[index])" :height="16" :width="16" />
            <span v-if="rating_value_list[index]" v-html="getRating(rating_value_list[index])"></span>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: flex-end" v-if="true">
        <div class="footer-container">
          <p class="footer-text">Was this review helpful?</p>
          <p>
            <font-awesome-icon v-if="!reaction.like" :icon="['fal', 'thumbs-up']" class="like-button" @click="setReactions('like', review.id)" />
            <font-awesome-icon v-else class="like-button" :icon="['fas', 'thumbs-up']" :style="{ color: getPrimaryColor() }" @click="deleteReaction(like_id, 'like', review.id, 'deleteLike')" />
            <font-awesome-icon v-if="!reaction.dislike" :icon="['fal', 'thumbs-down']" style="margin-left: 20px; cursor: pointer" @click="setReactions('dislike', review.id)" />
            <font-awesome-icon
              v-else
              class="like-button"
              :icon="['fas', 'thumbs-down']"
              :style="{ marginLeft: '20px', color: getPrimaryColor(), cursor: 'pointer' }"
              @click="deleteReaction(dislike_id, 'like', review.id, 'deleteDislike')"
            />
          </p>
        </div>
        <p class="footer-text" style="cursor: pointer" @click="setReactions('flag', review.id)" v-if="authUser.user.id !== review.reviewer[0].id || authUser.user.role !== review.reviewer[0].role">
          <span>
            <font-awesome-icon v-if="!reaction.flag" :icon="['fal', 'flag']" style="margin-right: 10px" />
            <font-awesome-icon v-else :icon="['fas', 'flag']" :style="{ marginRight: '10px', color: getPrimaryColor() }" />
          </span>
          Flag Review
        </p>
      </div>
    </div>
    <button v-if="showAllreviewsButton" class="view-button" :style="{ color: getPrimaryColor() }" @click="routeToReceivedReviews">View all reviews</button>
    <div v-if="loadingScreen" class="spinnerContainer-post">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFilter, faStar, faFlag, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp } from "@fortawesome/pro-solid-svg-icons"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import ReviewStar from "../../commons/ReviewStar.vue"

const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")
library.add(faFilter, faFlag, faStar, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp)

export default {
  name: "ReviewCard",
  props: { reviewData: Object, showAllreviewsButton: { default: false, type: Boolean }, isProfile: { default: true, type: Boolean } },
  components: { ReviewStar },
  data() {
    return {
      review: null,
      image: null,
      name: null,
      title: null,
      reviewType: null,
      rating_list: [
        "Ease of Appointment",
        "Cost of consultation",
        "Ease of use of technology",
        "Knowledgeability",
        "Satisfaction",
        "Compassion",
        "Wait time",
        "Friendliness of Staff",
        "Attentiveness",
        "Quality Time",
        "Politeness",
        "Knowledge",
        "Supportive",
        "Easy to interact with",
        "Empathy",
        "Active on the platform",
        "Length of Visit",
      ],
      rating_value_list: [],
      expand: false,
      time: "",
      description: null,
      seeMore: true,
      reaction: { flag: false, like: false, dislike: false },
      like_id: null,
      dislike_id: null,
      flag_id: null,
      loadingScreen: false,
    }
  },

  created() {
    this.review = this.reviewData
    console.log("in-app review:", this.review)
    this.reaction.flag = this.review.flag_reaction ? true : false
    this.reaction.like = this.review.like_reaction ? true : false
    this.reaction.dislike = this.review.dislike_reaction ? true : false
    this.flag_id = this.review.flag_reaction ? this.review.flag_reaction[0].id : null
    this.like_id = this.review.like_reaction ? this.review.like_reaction[0].id : null
    this.dislike_id = this.review.dislike_reaction ? this.review.dislike_reaction[0].id : null
    this.time = this.formatPostTime(this.review.created_at)
    if (this.review.reviewee_role === "doctor") {
      this.image = this.review.reviewee.url
      this.name = this.review.reviewee.first_name + " " + this.review.reviewee.last_name
      this.title = this.review.reviewee.title ? `, ${this.review.reviewee.title}` : ""
      this.reviewType = this.review.type
    } else if (this.review.reviewee_role === "hospital_administrator") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.hospital_name
    } else if (this.review.reviewee_role === "clinic_administrator") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.clinic_name
    } else if (this.review.reviewee_role === "nfp_administrator") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.nfp_name
    } else if (this.review.reviewee_role === "hcp") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.full_name
      this.reviewType = this.review.type
    }
    this.description = this.review.description
    this.rating_value_list.push(
      this.review.ease_of_appointment,
      this.review.cost_of_appointment,
      this.review.ease_of_use_of_technology,
      this.review.knowledge_ability,
      this.review.satisfaction,
      this.review.compassion,
      this.review.wait_time,
      this.review.friendliness,
      this.review.attentiveness,
      this.review.quality_time,
      this.review.politeness,
      this.review.knowledge,
      this.review.supportive,
      this.review.easy_to_interact_with,
      this.review.empathy,
      this.review.active_on_the_platform,
      this.review.length_of_visit
    )
    // console.log("after pushing:", this.rating_value_list)
  },
  methods: {
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (this.isDateToday(d)) {
        return "Today"
      }
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
    getLimitedDescription(description) {
      const div = document.createElement("div")
      div.innerHTML = description
      const text = div.textContent || div.innerText || ""

      return text.length > 150 ? text.substring(0, 150) + "..." : text
    },
    getRating(rating) {
      return parseFloat(rating).toFixed(1)
    },
    reactReview(rType, revId) {
      const REACTION_TYPES = { flag: 5, like: 2, dislike: 11 }
      const payload = {
        reacted_on_type: 10,
        reacted_on_id: revId,
        user: this.authUser.user.id,
        user_role: this.authUser.user.role || "",
        reaction_type: REACTION_TYPES[rType],
      }

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          this.reaction[rType] = true
          if (rType === "like") {
            this.like_id = res.data.data.id
          } else if (rType === "dislike") {
            this.dislike_id = res.data.data.id
          } else if (rType === "flag") {
            this.flag_id = res.data.data.id
          }
          this.$notification.success({
            message: "Successful",
            description: `${rType === "like" ? "Helpful" : rType === "dislike" ? "Unhelpful" : "Flag"} has been saved`,
          })
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: `Cannot ${rType}`,
          })
        })
    },
    deleteReaction(id, rType, revId, deleteType) {
      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${id.toString()}`, {
          headers,
        })
        .then(res => {
          if (deleteType === "deleteLike") {
            this.reaction["like"] = false
            this.$notification.success({
              message: "Successful",
              description: `Helpful has been unsaved`,
            })
          } else if (deleteType === "deleteDislike") {
            this.reaction["dislike"] = false
            this.$notification.success({
              message: "Successful",
              description: `Unhelpful has been unsaved`,
            })
          } else if (deleteType === "flag") {
            this.reaction[deleteType] = false
            this.$notification.success({
              message: "Successful",
              description: `Flag has been unsaved`,
            })
          } else {
            this.reaction[deleteType] = false
          }
          if (deleteType != "flag" && deleteType != "deleteLike" && deleteType != "deleteDislike") {
            this.reactReview(rType, revId)
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: `Cannot ${rType}`,
          })
        })
    },
    setReactions(rType, revId) {
      if (this.reviewType === "InPerson") {
        // do core actions
      } else {
        if (rType === "dislike") {
          if (this.reaction.like === true) {
            this.deleteReaction(this.like_id, rType, revId, "like")
          } else {
            this.reactReview(rType, revId)
          }
        } else if (rType === "like") {
          if (this.reaction.dislike === true) {
            this.deleteReaction(this.dislike_id, rType, revId, "dislike")
          } else {
            this.reactReview(rType, revId)
          }
        } else if (rType === "flag") {
          if (this.reaction.flag === true) {
            this.deleteReaction(this.flag_id, rType, revId, "flag")
          } else {
            this.reactReview(rType, revId)
          }
        }
      }
    },
    viewProfile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (!user.reviewee_mycircle_id) {
          this.routeProfile()
        } else {
          this.profile(type)
        }
      } else {
        this.profile(type)
      }
    },
    profile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("ext_ref_id")) {
          user["user_id"] = user.reviewee.ext_ref_id
        } else {
          user["user_id"] = user.reviewee.id
        }
        user["role"] = user.reviewee_role
      } else {
        user["user_id"] = user.reviewer_id
        user["role"] = user.reviewer_role
      }
      if (user.role === "admin") {
        return
      }
      this.loadingScreen = true
      if (user.user_id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(
          user.reviewee.hasOwnProperty("ext_ref_id") && type === "reviewee" ? { ext_ref_id: user.user_id, role: user.role } : { id: user.user_id, role: user.role },
          this.currentCircle.id
        )
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.user_id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.user_id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.user_id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id, role: "caregiver" },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.user_id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.user_id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.user_id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {
            this.loadingScreen = false
          })
      }
    },
    routeProfile(reviewee_role = this.review.reviewee_role, reviewee_id = this.review.reviewee_id) {
      this.loadingScreen = true
      switch (reviewee_role) {
        case "physician":
        case "providers":
        case "doctor":
          this.viewEntityProfile({
            role: "doctor",
            id: reviewee_id,
          })
          break
        case "other":
        case "hcp":
        case "hcp_administrator":
          this.viewEntityProfile({ role: "hcp", id: reviewee_id })
          break
        case "hospital":
        case "hospital_administrator":
          this.viewEntityProfile({ role: "hospital", id: reviewee_id })
          break
        case "clinic":
        case "clinic_administrator":
          this.viewEntityProfile({ role: "clinic", id: reviewee_id })
          break
        case "nfp":
        case "nfp_administrator":
          this.viewEntityProfile({ role: "nfp", id: reviewee_id })
          break
        case "Business":
          break
      }
    },
    routeToReceivedReviews(type = "reviewee") {
      const user = this.review
      if (!user.reviewee_mycircle_id) {
        user["user_id"] = user.reviewee.ext_ref_id
      } else {
        user["user_id"] = user.reviewee_mycircle_id
      }
      user["role"] = user.reviewee_role
      this.loadingScreen = true
      if (user.user_id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        if (!user.reviewee_mycircle_id) {
          UserRepository.getOtherEntityProfile({ role: user.role, ext_ref_id: user.user_id }, this.currentCircle.id)
            .then(res => {
              this.$store.commit("User/setViewUser", {
                data: { ...res.data.data, role: user.role, isDirectory: true },
              })
              this.$router.push({
                path: `/${this.currentCircle.key_name}/profile/view/${user.role}/${user.user_id}/receivedreviews/all`,
              })
            })
            .catch(err => {})
        } else {
          UserRepository.getOtherUserProfile(
            !user.reviewee_mycircle_id && type === "reviewee" ? { ext_ref_id: user.user_id, role: user.role } : { id: user.user_id, role: user.role },
            this.currentCircle.id
          )
            .then(res => {
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                no_of_members: res.data.data.no_of_members,
                recommendations: res.data.data.no_of_recommendations,
                recommend: res.data.data.recommend,
                overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
                inPersonReview: res.data.data.in_person_visit,
                onlineReview: res.data.data.online_tele_medicine,
                myCirclesReview: res.data.data.my_circle,
              }
              this.$store.commit("User/setViewUser", { data })
              this.$router.push({
                path: `/${this.currentCircle.key_name}/profile/view/${user.role}/${user.user_id}/receivedreviews/all`,
              })
            })
            .catch(err => {
              this.loadingScreen = false
            })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-view {
  display: flex;
  // margin-left: 16px;
  flex-wrap: wrap;
  // flex-direction: column;
  // flex-direction: row;
}
.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
  width: fit-content;
}

.text-day {
  // font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  // margin-left: 16px;
  margin-bottom: 0px;
}

.cont {
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media screen and (max-width: 900px) {
    display: none;
  }
}

.cont-mob {
  display: none;
  // display: flex;
  // flex-direction: column;
  // gap: 8px;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}

.text-name-2 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  margin-bottom: 4px;
}
.text-reviewed {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  text-transform: none;
  white-space: nowrap;
  padding-right: 10px;
  .icon {
    width: 24px;
  }
}

.text-link {
  @media only screen and (max-width: 500px) {
    display: none;
  }
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}
.view-button {
  @media only screen and (min-width: 501px) {
    // display: none;
  }
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  margin-top: 16px;
  border: none;
  font-weight: 700;
  font-size: 14px;
}
.str-grp {
  display: flex;
  gap: 8px;
  height: 24px;
  align-items: center;
}
.star-cont {
  display: flex;
  // gap: 24px;
  gap: 16px;
  align-items: center;
}
.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  // margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.review-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  padding-top: 16px;
}

.see-more {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #94a3b8;
  cursor: pointer;
}

.rate-box-container {
  display: flex;
  row-gap: 16px;
  column-gap: 8px;
  flex-wrap: wrap;
  padding-bottom: 30px;
  @media only screen and (max-width: 500px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

.rate-box {
  font-weight: 700;
  font-size: 12px;
  color: #0f1734;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  text-transform: capitalize;
  display: flex;
  gap: 8px;
  align-items: center;
  @media only screen and (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: start;
  }
}

.footer-container {
  display: flex;
  @media only screen and (max-width: 500px) {
    flex-direction: column;
    gap: 24px;
  }
}

.footer-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
}
.like-button {
  margin-left: 20px;
  @media only screen and (max-width: 500px) {
    margin-left: 0px;
  }
  cursor: pointer;
}
.divider-line {
  @media only screen and (max-width: 900px) {
    display: none;
  }
}
.divider-line-mob {
  @media only screen and (min-width: 901px) {
    display: none;
  }
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/ReviewTabCard.vue